import { OneSignal } from 'react-native-onesignal';
import { isWeb } from '../../config/designSystem/Layout';

export const optIn = async () => {
  if(!isWeb) {
    if(OneSignal.Notifications.hasPermission()) {
      OneSignal.User.pushSubscription.optIn();
    } else {
      OneSignal.User.pushSubscription.optOut();
    }
  }
};